import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CacheInterceptorService implements HttpInterceptor {

  public intercept(req: HttpRequest<any>, next: HttpHandler) {
    req.headers.set('Cache-Control', 'no-cache');
    req.headers.set('Pragma', 'no-cache');
    req.headers.set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');

    return next.handle(req);
  }
}
